/* By Mikaye storefront behaviour. Loop safe. */

(function () {
  var CONFIG = {
    requireSizeChoice: true,
    doubleTapMs: 340,
    tapSlopPx: 12,
    tapDistancePx: 44,
    fetchThrottleMs: 400
  };

  var HEADING_FIXES = {
    'customer reviews': 'CUSTOMER REVIEWS',
    'featured in': 'FEATURED IN',
    'keep the bounce going, tag @bymikaye': 'Keep the bounce going, tag @bymikaye',
    'keep the bounce going tag @bymikaye': 'Keep the bounce going, tag @bymikaye'
  };

  var isPainting = false, lastFetch = 0, trailing = null, inFlight = false;
  var sizeChosen = false;

  function money(cents) {
    var v = cents / 100;
    var s = v % 1 === 0 ? v.toFixed(0) : v.toFixed(2);
    return '$' + s.replace(/\B(?=(\d{3})+(?!\d))/, ',');
  }

  function setText(el, value) {
    if (el && el.textContent !== value) el.textContent = value;
  }

  function fixHeadings() {
    document.querySelectorAll('h1, h2, h3, h4, h5, h6, .h1, .h2, .h3, .h4, .h5, .h6, .subtitle, p')
      .forEach(function (el) {
        if (el.dataset.bmkHeading === '1') return;
        if (el.children.length) return;
        var key = el.textContent.trim().toLowerCase();
        if (HEADING_FIXES[key]) {
          el.textContent = HEADING_FIXES[key];
          el.style.textTransform = 'none';
          el.dataset.bmkHeading = '1';
        }
      });
  }

  /* ==========================================================
     Shipping, delivery-date and totals display are now handled
     server-side by Liquid in snippets/cart-drawer.liquid and
     sections/main-cart-items.liquid, keyed to the real Delivery
     Profiles (Express/Standard/Free by product handle). This
     function used to recompute and overwrite those same fields
     with a stale flat $95/$6.99 rule and a fixed 8-11 day
     window, silently overriding the correct server-rendered
     values on every cart load and update. It now only keeps the
     subtotal display and the "+N other items" note in sync,
     which are harmless duplicates of what the server already
     renders.
     ========================================================== */
  function paintCart(cart) {
    if (!cart) return;
    isPainting = true;
    try {
      var subtotal = cart.total_price || 0;
      var count = cart.item_count || 0;

      document.querySelectorAll('[data-bmk-subtotal]').forEach(function (el) { setText(el, money(subtotal)); });

      document.querySelectorAll('[data-bmk-subtotal-label]').forEach(function (el) {
        setText(el, count === 1 ? 'Subtotal' : 'Subtotal (' + count + ' items)');
      });

      document.querySelectorAll('[data-bmk-more]').forEach(function (el) {
        var extra = count - 1;
        if (extra > 0) {
          el.hidden = false;
          setText(el, 'Plus ' + extra + (extra === 1 ? ' other item' : ' other items') + ' already in your bag');
        } else {
          el.hidden = true;
        }
      });
    } finally {
      setTimeout(function () { isPainting = false; }, 60);
    }
  }

  function refreshCart(force) {
    var now = Date.now();
    var wait = CONFIG.fetchThrottleMs - (now - lastFetch);

    if (!force && (wait > 0 || inFlight)) {
      clearTimeout(trailing);
      trailing = setTimeout(function () { refreshCart(true); }, Math.max(wait, 60) + 40);
      return;
    }

    lastFetch = Date.now();
    inFlight = true;

    fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { inFlight = false; paintCart(cart); })
      .catch(function () {
        inFlight = false;
        clearTimeout(trailing);
        trailing = setTimeout(function () { refreshCart(true); }, 600);
      });
  }

  function queueRefresh() { refreshCart(false); }

  /* ---------- no size preselected ---------- */
  var SIZE_GROUP = '.product-parameters--button .product-form__controls:not(.product-form__controls--colors)';

  function sizeGroups() { return document.querySelectorAll(SIZE_GROUP); }

  function clearSizeSelection() {
    if (!CONFIG.requireSizeChoice || sizeChosen) return;
    sizeGroups().forEach(function (group) {
      group.querySelectorAll('input[type="radio"]').forEach(function (input) {
        if (input.checked) input.checked = false;
      });
    });
  }

  function warnEl() {
    var host = document.querySelector(SIZE_GROUP);
    if (!host) return null;
    var el = document.getElementById('bmk-size-warning');
    if (el) return el;
    el = document.createElement('p');
    el.id = 'bmk-size-warning';
    el.setAttribute('role', 'alert');
    el.textContent = 'Please select a size.';
    el.style.cssText = 'margin:1rem 0 0;font-size:1.45rem;font-weight:500;color:#9E3B26;display:none;';
    if (host.parentNode) host.parentNode.insertBefore(el, host.nextSibling);
    return el;
  }

  function flagMissingSize() {
    var el = warnEl();
    if (el) el.style.display = 'block';
    sizeGroups().forEach(function (group) {
      var grid = group.querySelector('.product-form__controls-group');
      if (grid) grid.style.boxShadow = '0 0 0 0.15rem #9E3B26';
      group.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }

  function clearMissingSize() {
    var el = document.getElementById('bmk-size-warning');
    if (el) el.style.display = 'none';
    sizeGroups().forEach(function (group) {
      var grid = group.querySelector('.product-form__controls-group');
      if (grid) grid.style.boxShadow = '';
    });
  }

  function hasSize() {
    if (!CONFIG.requireSizeChoice) return true;
    var groups = sizeGroups();
    if (!groups.length) return true;
    var ok = true;
    groups.forEach(function (group) {
      if (!group.querySelector('input[type="radio"]:checked')) ok = false;
    });
    return ok;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.product-form__submit, button[name="add"]');
    if (!btn || hasSize()) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    flagMissingSize();
  }, true);

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.action || form.action.indexOf('/cart/add') === -1) return;
    if (hasSize()) return;
    e.preventDefault();
    e.stopPropagation();
    flagMissingSize();
  }, true);

  /* ---------- double tap to zoom ---------- */
  var WANTED = /(zoom|enlarge|expand|fullscreen|full-screen|magnif|lightbox|view-image|image-modal|icon-plus|plus)/i;
  var UNWANTED = /(thumb|prev|next|arrow|slide|dot|pagination|close|play|pause|mute|quantity|qty|minus|cart|wish)/i;

  var MEDIA_SEL = '.product__media-wrapper, .product__media, .product-media, .product__media-item, ' +
                  '.product__media-list, media-gallery, .product-gallery, .product__media-gallery, ' +
                  '.swiper-slide-active, [class*="media-gallery"], [class*="product-single__photo"]';

  function describe(el) {
    var svg = el.querySelector('svg, use');
    return [
      el.className || '', el.id || '',
      el.getAttribute('aria-label') || '',
      el.getAttribute('title') || '',
      svg ? (svg.getAttribute('class') || '') : ''
    ].join(' ');
  }

  function zoomControlsIn(scope) {
    var out = [];
    scope.querySelectorAll('button, a, [role="button"], modal-opener').forEach(function (c) {
      var text = describe(c);
      if (UNWANTED.test(text)) return;
      if (WANTED.test(text)) out.push(c.tagName === 'MODAL-OPENER' ? (c.querySelector('button') || c) : c);
    });
    return out;
  }

  function findZoomControl(from) {
    var scope = from.closest(MEDIA_SEL) || from.closest('.product, main') || document.body;
    var hops = 0;
    while (scope && hops < 6) {
      var found = zoomControlsIn(scope);
      if (found.length) return found[0];
      scope = scope.parentElement ? scope.parentElement.closest(MEDIA_SEL + ', .product, main') : null;
      hops++;
    }
    return null;
  }

  function isMedia(target) {
    if (!target || !target.closest) return null;
    if (target.closest('[class*="thumb"], .swiper-thumbs')) return null;
    if (target.closest('button, a, [role="button"], video, iframe, .product-form__controls')) return null;
    return target.closest(MEDIA_SEL) || (target.tagName === 'IMG' ? target : null);
  }

  var lastTap = null, touchStart = null;

  document.addEventListener('touchstart', function (e) {
    var t = e.changedTouches[0];
    touchStart = { x: t.clientX, y: t.clientY };
  }, { passive: true });

  document.addEventListener('touchend', function (e) {
    if (!touchStart) return;
    var t = e.changedTouches[0];
    var travel = Math.abs(t.clientX - touchStart.x) + Math.abs(t.clientY - touchStart.y);
    touchStart = null;
    if (travel > CONFIG.tapSlopPx) { lastTap = null; return; }
    if (!isMedia(e.target)) { lastTap = null; return; }

    var now = Date.now();
    if (lastTap &&
        now - lastTap.time < CONFIG.doubleTapMs &&
        Math.abs(t.clientX - lastTap.x) < CONFIG.tapDistancePx &&
        Math.abs(t.clientY - lastTap.y) < CONFIG.tapDistancePx) {
      lastTap = null;
      var btn = findZoomControl(e.target);
      if (btn) btn.click();
      return;
    }
    lastTap = { time: now, x: t.clientX, y: t.clientY };
  }, { passive: true });

  document.addEventListener('dblclick', function (e) {
    if (!isMedia(e.target)) return;
    var btn = findZoomControl(e.target);
    if (btn) btn.click();
  });

  /* ---------- product options ---------- */
  var SIZE_RE = /^\s*([^(]+?)\s*\(([^)]+)\)\s*$/;

  function stackSizes() {
    sizeGroups().forEach(function (group) {
      group.querySelectorAll('label').forEach(function (label) {
        if (label.dataset.bmkStacked === '1') return;
        var m = SIZE_RE.exec(label.textContent);
        if (!m) return;
        label.innerHTML =
          '<span class="bmk-size-letter">' + m[1].trim() + '</span>' +
          '<span class="bmk-size-range">' + m[2].trim().replace(/-/g, '\u2013') + '</span>';
        label.dataset.bmkStacked = '1';
      });
    });
  }

  function paintLabels() {
    document.querySelectorAll('.product-form__controls').forEach(function (group) {
      var name = group.querySelector('.product-form__group-name');
      if (!name) return;

      var base = name.dataset.bmkBase;
      if (!base) {
        base = (name.childNodes[0] ? name.childNodes[0].textContent : name.textContent)
          .replace(/[:\s]+$/, '').trim();
        name.dataset.bmkBase = base;
      }

      var checked = group.querySelector('input[type="radio"]:checked');
      var select = group.querySelector('select');
      var value = checked ? checked.value : (select ? select.value : null);
      if (!value && base.toLowerCase().indexOf('size') === 0) value = 'Select a size';

      var html = value ? base + ': <span>' + value + '</span>' : base;
      if (name.innerHTML !== html) name.innerHTML = html;
    });
  }

  function markZoomable() {
    document.querySelectorAll('.product__media-wrapper img, .product__media img, .product-media img')
      .forEach(function (img) {
        if (img.closest('[class*="thumb"]')) return;
        if (img.style.cursor !== 'zoom-in') img.style.cursor = 'zoom-in';
      });
  }

  function paintProduct() {
    if (isPainting) return;
    isPainting = true;
    try {
      stackSizes();
      clearSizeSelection();
      paintLabels();
      markZoomable();
      fixHeadings();
    } finally {
      setTimeout(function () { isPainting = false; }, 60);
    }
  }

  function init() {
    paintProduct();
    refreshCart(true);

    document.addEventListener('change', function (e) {
      var group = e.target.closest && e.target.closest('.product-form__controls');
      if (!group) return;
      if (group.matches(SIZE_GROUP)) {
        sizeChosen = true;
        clearMissingSize();
      }
      setTimeout(paintProduct, 0);
    });

    var picker = document.querySelector('.product-parameters');
    if (picker) {
      var t = null;
      new MutationObserver(function () {
        if (isPainting) return;
        clearTimeout(t);
        t = setTimeout(paintProduct, 120);
      }).observe(picker, { childList: true, subtree: true });
    }

    if (window.PUB_SUB_EVENTS && typeof subscribe === 'function') {
      subscribe(window.PUB_SUB_EVENTS.cartUpdate, queueRefresh);
    }

    ['CartNotification', 'CartDrawer'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) new MutationObserver(queueRefresh).observe(el, { childList: true, subtree: false });
    });

    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('cart-drawer, cart-notification, .cart-items')) {
        setTimeout(function () { refreshCart(false); }, 250);
        setTimeout(function () { refreshCart(true); }, 900);
      }
    });

    document.addEventListener('submit', function (e) {
      if (e.target.action && e.target.action.indexOf('/cart') !== -1) {
        setTimeout(function () { refreshCart(true); }, 500);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
